// Game Core 共用型別定義
// 對應 PRD §13 資料模型
//
// 所有 Core 模組共用的基本型別都集中在這裡，
// 避免到處重複宣告，也方便未來在 i18n / UI 層直接 import 對應資料。
//
// 命名規範（見專案 CLAUDE.md）：每個聯集 type 都有同名 const 配對，
// 程式碼一律用 const 的具名值（如 Wind.East）填值，不直接寫字串字面值。

/**
 * 麻將四家位置 const。
 * 編號從玩家自己順時針：0=玩家、1=右家、2=對家、3=左家。
 */
export const Seat = {
  Self: 0,
  Right: 1,
  Opposite: 2,
  Left: 3,
} as const;

/**
 * 麻將四家位置型別。
 * 玩家目前固定坐 Seat.Self；莊家由牌局組起莊骰與跨局結果決定。
 */
export type TSeat = (typeof Seat)[keyof typeof Seat];

/**
 * seat → 相對玩家的方位序（0=自家、1=下家、2=對家、3=上家）。
 * 回合指示手勢、結算座位字 / 頭像都靠這個把絕對 seat 換成相對方位。
 */
export const seatToRelative = (seat: TSeat, playerSeat: TSeat): number =>
  (seat - playerSeat + 4) % 4;

/**
 * 門風 / 圈風 const。牌局組依序推進東、南、西、北圈。
 */
export const Wind = {
  East: 'east',
  South: 'south',
  West: 'west',
  North: 'north',
} as const;

/** 門風（每家擁有一個）/ 圈風（全局一個）型別。 */
export type TWind = (typeof Wind)[keyof typeof Wind];

export const RoundIndex = {
  East: 1,
  South: 2,
  West: 3,
  North: 4,
} as const;

export type TRoundIndex = (typeof RoundIndex)[keyof typeof RoundIndex];

/**
 * 牌的花色 const。
 * - Man（萬）/ Pin（筒）/ Sou（條）：數牌 1–9，各 4 張
 * - Wind（風）：東南西北 4 張，各 4 張
 * - Dragon（元）：中發白 3 張，各 4 張
 * - Flower（花）：春夏秋冬梅蘭竹菊 8 張，各 1 張
 */
export const Suit = {
  Man: 'man',
  Pin: 'pin',
  Sou: 'sou',
  Wind: 'wind',
  Dragon: 'dragon',
  Flower: 'flower',
} as const;

export type TSuit = (typeof Suit)[keyof typeof Suit];

/**
 * 簡單的隨機數產生器介面。
 * 回傳 0..1 之間的浮點數（同 Math.random 介面），
 * 但 Core 內所有隨機都走這個介面，方便注入 seedable RNG 做測試重現。
 */
export type TRng = () => number;
